import { Controller } from '@hotwired/stimulus'
// @ts-expect-error
import Sortable from 'sortablejs'

export default class extends Controller {
  static values = {
    url: String,
    parentId: String
  }

  declare urlValue: string
  declare parentIdValue: string

  sortable: Sortable

  connect (): void {
    this.sortable = Sortable.create(this.element, {
      group: 'shared',
      animation: 150,
      handle: '.sortable-handle',
      filter: '.ignore-elements',
      onEnd: this.end.bind(this),
      onMove: this.onMove.bind(this)
    })
  }

  onMove (evt: any): boolean {
    const fromParentId = evt.from.dataset.subcategorySortableParentIdValue
    const toParentId = evt.to.dataset.subcategorySortableParentIdValue
    return fromParentId === toParentId
  }

  end (event: any): void {
    const id = event.item.dataset.id
    const data = new FormData()
    data.append('position', `${parseInt(event.newIndex) + 1}`)

    const destinationParentId = event.to.dataset.subcategorySortableParentIdValue
    if (typeof destinationParentId === 'string' && destinationParentId.length > 0) {
      data.append('parent_id', destinationParentId)
    }

    void fetch(this.urlValue.replace(':id', id), {
      method: 'PATCH',
      body: data,
      headers: {
        Accept: 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? ''
      }
    })
  }
}
